export default "__VITE_ASSET__BCSHYZpJ__"